import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent, DialogFooterComponent, DialogHeaderComponent } from '@akostm/orbit-ui';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { faSave } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'lib-tenant-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonComponent,
    DialogHeaderComponent,
    DialogFooterComponent,
    FontAwesomeModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './tenant-dialog.component.html',
  styleUrls: ['./tenant-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantDialogComponent {
  dialogRef = inject(DialogRef);
  data: any = inject(DIALOG_DATA);

  // Font Awesome icons
  readonly saveIcon = faSave;

  closeDialog(save: boolean): void {
    this.dialogRef.close(save);
  }
}
